import { applyBiometricThemeVariables } from '@/config/biometricTheme'

/**
 * replace all strings
 * @param {string} str
 * @param {string} find
 * @param {string} replace
 * @returns {string}
 */
export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace)
}

/**
 * set layout details
 * @param {object} config
 */
export function setLayoutPortal(config) {
  document.documentElement.style.setProperty('--background-color', config['background-color'])
  document.documentElement.style.setProperty('--background-button', config['background-button'])
  document.documentElement.style.setProperty('--text-primary-color', config['text-primary-color'])
  document.documentElement.style.setProperty('--text-secondary-color', config['text-secondary-color'])

  if (config['text-tertiary-color']) {
    document.documentElement.style.setProperty('--text-tertiary-color', config['text-tertiary-color'])
  } else {
    document.documentElement.style.setProperty('--text-tertiary-color', config['text-secondary-color'])
  }

  // Text button color
  if (config['text-button-color']) {
    document.documentElement.style.setProperty('--text-button-color', config['text-button-color'])
  }

  // Input color
  if (config['background-input']) {
    document.documentElement.style.setProperty('--background-input', config['background-input'])
  }

  if (config['text-input-color']) {
    document.documentElement.style.setProperty('--text-input-color', config['text-input-color'])
  }

  // Text privacy policy color
  if (config['text-privacy-policy-color']) {
    document.documentElement.style.setProperty('--text-privacy-policy-color', config['text-privacy-policy-color'])
  }

  // Paleta dos fluxos biométricos: usa o que a API enviar e cai no default da proposta de UX
  applyBiometricThemeVariables(config)

  // Register font
  function registerFont(fontName) {
    const fontPath = `/fonts/${fontName}.ttf`
    const styleSheet = document.createElement('style')
    styleSheet.textContent = `
        @font-face {
            font-family: '${fontName}';
            src: url('${fontPath}') format('truetype');
        }
    `
    document.head.appendChild(styleSheet)
  }

  // Font Type
  if (config['font-title']) {
    const fontName = config['font-title']
    registerFont(fontName)
    document.documentElement.style.setProperty('--font-family-title', `'${fontName}'`)
  }

  if (config['font-subTitle']) {
    const fontName = config['font-subTitle']
    registerFont(fontName)
    document.documentElement.style.setProperty('--font-family-subtitle', `'${fontName}'`)
  }

  if (config['font-label']) {
    const fontName = config['font-label']
    registerFont(fontName)
    document.documentElement.style.setProperty('--font-family-label', `'${fontName}'`)
  }

  if (config['font-button']) {
    const fontName = config['font-button']
    registerFont(fontName)
    document.documentElement.style.setProperty('--font-family-button', `'${fontName}'`)
  }

  if (config['font-text']) {
    const fontName = config['font-text']
    registerFont(fontName)
    document.documentElement.style.setProperty('--font-family-text', `'${fontName}'`)
  }

  // create a link to a favicon
  var link = document.createElement('link')
  link.rel = 'shortcut icon'
  link.type = 'image/x-icon'
  link.href = config.logo

  // get link
  var favicon = document.querySelector('link[rel="shortcut icon"]') || document.querySelector('link[rel="icon"]')

  // delete favicon
  if (favicon) {
    document.head.removeChild(favicon)
  }

  // add new favicon
  document.head.appendChild(link)

  // update
  document.title = `${document.title} | ${config.name}`
}

/**
 * delete special characters
 * @param {object} config
 */
export function removeSpecialCharacters(str) {
  return str.replace(/[^\w\s]/gi, '')
}

/**
 * get router by step
 * @param {object} config
 */
export function getRouterToStep(step) {
  const routers = {
    selfie: 'selfie',
    documents: 'documents',
    resume: 'resume'
  }

  if (step in routers) {
    return routers[step]
  }

  return null
}

export function withTrailingSlash(url) {
  return url.endsWith('/') ? url : `${url}/`
}
